import { useAuthStorage } from '@data';
import {
  initAccessTokenValidatorContainer,
  initGraphContainer,
  initPhishedContainer,
} from '@utils-global';
import { useEffect, useLayoutEffect } from 'react';

export const useContainerInit = () => {
  const { graphToken, idToken } = useAuthStorage();

  useEffect(() => {
    initAccessTokenValidatorContainer();
  }, []);

  useLayoutEffect(() => {
    if (graphToken) {
      initGraphContainer(graphToken);
    }
  }, [graphToken]);

  useLayoutEffect(() => {
    initPhishedContainer(idToken || undefined);
  }, [idToken]);
};
